(function (Drupal, $, once) {
  'use strict';

  Drupal.behaviors.stickyHeader = {

    attach: function attach(context) {
      // The scroll handler belongs to the window, so it binds on the first
      // attach only. Later AJAX attaches pass a fragment that has no <html>.
      once('sticky-header-scroll', 'html', context).forEach(() => {
        const scrollCheck = () => {
          const $container = $('.layout-container');
          if (!$container.length) {
            return;
          }

          if ($(window).scrollTop() > $container.offset().top) {
            $('header').addClass('sticky');
          } else {
            $('header').removeClass('sticky');
          }
        };

        $(window).on('scroll', scrollCheck);
        $(scrollCheck);
      });

      // Desktop menu
      $(once('sticky-header-desktop', '.layout__region--header .block-menu-block-dennys-mainnavigation .dropdown-item', context)).on('click', function (e) {
        // Aria for accessibility
        if($(this).attr('aria-expanded') === 'true') {
          $(this).attr('aria-expanded', 'false');
        } else {
          $(this).attr('aria-expanded', 'true');
        }
        $('.layout__region--header').toggleClass('dropdown-open');
        e.preventDefault();
        return false;
      });
      // Mobile Menu
      $(once('sticky-header-mobile', '.layout__region--mobile-header .dropdown-item', context)).on('click', function (e) {
        // Aria for accessibility
        if($('.layout__region--mobile-header .dropdown-item').attr('aria-expanded') === 'true') {
          $('.layout__region--mobile-header .dropdown-item').attr('aria-expanded', 'false');
        } else {
          $('.layout__region--mobile-header .dropdown-item').attr('aria-expanded', 'true');
        }
        $('.layout__region--mobile-header').toggleClass('dropdown-open');
        e.preventDefault();
        return false;
      });
      // The flyout's open, close and focus handling lives in sidebar.js.
    }
  };
})(Drupal, jQuery, once);
